import { render, staticRenderFns } from "./ColumnStatistics.vue?vue&type=template&id=46b0f188"
import script from "./ColumnStatistics.vue?vue&type=script&lang=js"
export * from "./ColumnStatistics.vue?vue&type=script&lang=js"
import style0 from "./ColumnStatistics.vue?vue&type=style&index=0&id=46b0f188&prod&lang=postcss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports